import type { ComponentType } from 'react';

export const getDisplayName = <P extends object>(Comp: ComponentType<P>) =>
  Comp.displayName || Comp.name || 'Component';
